// util/isEmpty.js
/**
 * Checks if data is empty (null, undefined, empty array/object/string)
 * @param {*} data - Any value to check
 * @returns {boolean}
 */
 // By FAC on 12/19/2025

export default function isEmpty(data) {
    if (data == null) return true;
    if (Array.isArray(data)) return data.length === 0;
    if (typeof data === 'object') return Object.keys(data).length === 0;
    if (typeof data === 'string') return data.trim() === '';
    return false;
}

